<app-header></app-header>
<ion-header>
  <ion-toolbar>
    <ion-title>
      Settings
    </ion-title>
</ion-toolbar>
</ion-header>
<!-- <ion-content class="ion-padding">
  <p>user-settings page loaded!</p>
</ion-content> -->
<ion-title>
  Settings
</ion-title>
<ion-content class="ion-text-center ion-padding">
  <ion-list>
    <ion-item>
      <ion-label>First Name</ion-label>
      <ion-label> {{this.userProfile.firstName}} </ion-label>
    </ion-item>
    <ion-item>
      <ion-label>Last Name</ion-label>
      <ion-label> {{this.userProfile.lastName}} </ion-label>
    </ion-item>
    <ion-item text-wrap>
      <ion-label>Email</ion-label>
      <ion-label class="ion-text-wrap">{{this.userProfile.emailId}}</ion-label>
      <!-- <ion-label>{{this.userProfile.emailId}}</ion-label> -->
    </ion-item>
    <ion-item>
      <ion-label>Phone number</ion-label>
      <ion-label>{{this.userProfile.phoneNumber}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label>Role</ion-label>
      <ion-label>{{this.userProfile.roles}}</ion-label>
    </ion-item>
    <ion-item>
      <ion-label>Use Passcode</ion-label>
      <ion-toggle
        [(ngModel)]="usePasscode"
        (ionChange)="authModeChanged()"
        [disabled]="useSecureStorageMode"
      ></ion-toggle>
    </ion-item>
    <ion-item>
      <ion-label>Lock</ion-label>
      <ion-button (click)="lock()"
        ><ion-icon name="lock-open"></ion-icon
      ></ion-button>
    </ion-item>
  </ion-list>
</ion-content>
